import { createFileRoute } from '@tanstack/react-router'
import RoyaltySalesChannelsForm from 'Administration/components/royalty/royaltySalesChannels/RoyaltySalesChannelsForm'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/royaltySalesChannels')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <RoyaltySalesChannelsForm />
            </AdministrationPage>
        </Guard>
    ),
})
